import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { cookies, CCSRFToken } from 'libs/api/apiClient';
import { deleteAccount } from 'libs/api/user';
import { TModalProps } from 'modules/types';
import { ERoute } from 'enums/route.enum';
import { Modal, Button, Checkbox, Typography } from 'antd';
import { CheckSquareTwoTone } from '@ant-design/icons';
import { Colors } from 'GlobalStyles';

const { Text } = Typography;

const DeleteAccountConfirmModal = ({ modalState, setModalState }: TModalProps) => {
  const history = useHistory();
  const [visible, setVisible] = useState(false);
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  const [isChecked, setIsChecked] = useState<boolean>(false);

  async function logout() {
    try {
      // await userLogout();
      cookies.remove('sessionid');
      cookies.remove(CCSRFToken);
      window.location.href = ERoute.UserLogin;
      window.localStorage.removeItem(CCSRFToken);
    } catch (e) {
      throw e;
    }
  }

  async function onClickSubmit() {
    if (isChecked) {
      const { data } = await deleteAccount();
      logout();
      //노티 메시지
      // showNotification('success', <div style={{lineHeight:0.7}}><p>탈퇴가 완료되었습니다.</p><p>메인페이지로 돌아갑니다.</p></div>)
      //모달창 닫기
      handleCancel();
    }
  }

  const onCheck = (e: any) => {
    setIsChecked(e.target.checked);
  };

  const handleCancel = () => {
    setModalState({ visible: false, record: '' });
  };

  useEffect(() => {
    setVisible(modalState.visible);
  }, [modalState.visible]);

  return (
    <Modal
      title={<span style={{ fontSize: '25px' }}>탈퇴 확인</span>}
      visible={visible}
      centered={true}
      maskClosable={true}
      closable={true}
      footer={null}
      onCancel={handleCancel}
      width={600}
    >
      <div style={{ marginTop: '-20px' }}>
        <p>정말 탈퇴하시겠습니까? </p>
        <div style={{ marginBottom: '20px' }}>
          <CheckSquareTwoTone twoToneColor='#FBBC05' />
          <Text style={{ display: 'block' }}>
            {' '}
            &#183; 회원 탈퇴 시 사용자 정보는 1개월 간 보관 후, 탈퇴 시점 1개월 뒤에 삭제됩니다.
          </Text>
          <Text style={{ display: 'block' }}> (1개월 내 재가입 시 정보 복구 가능)</Text>
          <Text style={{ display: 'block' }}>
            {' '}
            &#183; 미사용 수강권, 미정산 내역 등 환금 가능한 정보도 1개월 뒤에 삭제되니 주의해주세요.
          </Text>
        </div>
        <Checkbox onChange={onCheck} style={{ color: `${Colors.grey2}` }}>
          {' '}
          주의사항을 확인했습니다.
        </Checkbox>
        <div style={{ height: '40px' }}>
          <Button
            type='primary'
            htmlType='submit'
            size='large'
            onClick={onClickSubmit}
            loading={submitButtonDisabled}
            style={{ float: 'right' }}
            disabled={!isChecked}
          >
            탈퇴하기
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteAccountConfirmModal;
